module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-album-6e4c3662cd539d02f3d6312c256ae9d6.png";